import MggpPluginDvr from '..';
import { PLAYER_EVENT } from '../types';

function subscribeOrUnsubscribe(plugin: MggpPluginDvr, isSubscribing: boolean) {
  const targetMethod = plugin.player[isSubscribing ? 'on' : 'off'];
  targetMethod(
    PLAYER_EVENT.currentProgramChanged,
    plugin.onCurrentProgramChanged
  );
  targetMethod(PLAYER_EVENT.playProgram, plugin.onPlayCatchup);
  targetMethod(PLAYER_EVENT.backOnAir, plugin.onBackOnAir);
  targetMethod(PLAYER_EVENT.seek, plugin.onSeek);
  targetMethod(PLAYER_EVENT.stateChange, plugin.onStateChange);
  targetMethod(PLAYER_EVENT.timeUpdate, plugin.onTimeUpdate);
  targetMethod(PLAYER_EVENT.disablePlugin, plugin.disablePlugin);
  targetMethod(PLAYER_EVENT.positionChange, plugin.onPositionChanged);
  targetMethod(PLAYER_EVENT.durationChange, plugin.onDurationChanged);
  targetMethod(
    PLAYER_EVENT.channelSwitch,
    plugin.onChannelSwitch
  );
}

export function subscribeOnEvents(plugin: MggpPluginDvr): void {
  subscribeOrUnsubscribe(plugin, true);
}

export function unsubscribeFromEvents(plugin: MggpPluginDvr): void {
  subscribeOrUnsubscribe(plugin, false);
}
